import React, { Component } from "react";
import ISPConfirm from "./ispConfirm";
import "../Form/proposalForm.css";

export default class ISPDetailsModal extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.show !== prevProps.show) {
      document.body.style.overflow = this.props.show ? "hidden" : "unset";
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "unset";
  }

  normalizeBoolean = (value) => {
    return value === true || value === "true";
  };

  formatClientName = (client = {}) => {
    if (client.clientName) return client.clientName;
    if (client.name) return client.name;

    return [client.firstName, client.middleName, client.lastName]
      .filter(Boolean)
      .join(" ")
      .trim();
  };

  normalizeISPState = (proposal) => {
    if (!proposal?.ispFormData) return null;

    try {
      const parsed = JSON.parse(proposal.ispFormData);
      const riskScores = parsed.riskScores || {};
      const registrations =
        Array.isArray(parsed.registrations) && parsed.registrations.length > 0
          ? parsed.registrations
          : [
              {
                registration: "registration0",
                value: parsed.registration || proposal.REGISTRATION || "",
                percentage: "100",
              },
            ];
      const jointClients = Array.isArray(parsed.jointClients)
        ? parsed.jointClients.map((client, index) => ({
            ...client,
            clientName:
              this.formatClientName(client) || `Client ${index + 1}`,
          }))
        : [];

      return {
        advisorName: parsed.advisorName || proposal["ADVISOR NAME"] || "",
        custodian: parsed.custodian || proposal.ispCustodian || "",
        strategy: parsed.strategy || proposal.program || "",
        bondType: parsed.bondType || proposal.ispBondType || "Taxable",
        pathBondType:
          parsed.pathBondType || proposal.ispPathBondType || "",
        pathStrategy:
          parsed.pathStrategy || proposal.ispPathStrategy || "",
        pathIarFeeType:
          parsed.pathIarFeeType || proposal.ispPathIarFeeType || "Fixed Percentage",
        pathIarFeeFlat:
          parsed.pathIarFeeFlat || proposal.ispPathIarFeeFlat || "",
        pathIarFeeTiered:
          parsed.pathIarFeeTiered || proposal.ispPathIarFeeTiered || [],
        registrations,
        requestType: parsed.requestType || proposal.ispRequestType || "",
        existingRequestAction:
          parsed.existingRequestAction || proposal.ispExistingRequestType || "",
        accountNumber: parsed.accountNumber || proposal.ispAccountNumber || "",
        householding: parsed.householding || proposal.ispHouseholding || "",
        householdRef: parsed.householdRef || proposal.ispHouseholdRef || "",
        householdReason:
          parsed.householdReason || proposal.ispHouseholdReason || "",
        initialInvestmentAmount:
          parsed.initialInvestmentAmount || proposal.VALUE || "",
        accountNetWorthPct:
          parsed.accountNetWorthPct || proposal.ispNetWorthPct || "",
        accountIncomeNeed: parsed.accountIncomeNeed || proposal.ispIncomeNeed || "",
        accountGoal: parsed.accountGoal || proposal.ispPrimaryGoal || "",
        accountGoalOther: parsed.accountGoalOther || proposal.ispGoalExplain || "",
        minorName: parsed.minorName || proposal.ispMinorName || "",
        relationshipToCustodian:
          parsed.relationshipToCustodian ||
          proposal.ispRelationshipToCustodian ||
          "",
        businessName: parsed.businessName || proposal.ispBusinessName || "",
        businessEinLast4:
          parsed.businessEinLast4 || proposal.ispBusinessEinLast4 || "",
        sourceOfFunds: Array.isArray(parsed.sourceOfFunds)
          ? parsed.sourceOfFunds
          : [],
        jointClients,
        combinedScore:
          riskScores.combinedScore ?? proposal.ispCombinedScore ?? "",
        riskCategory: riskScores.riskCategory || proposal.ispRiskCategory || "",
        selectedPortfolio:
          riskScores.selectedPortfolio || proposal["RISK TOLERANCE"] || "",
        portfolioOverride: this.normalizeBoolean(
          riskScores.portfolioOverride ?? proposal.ispPortfolioOverride,
        ),
        iarFeeTier: parsed.iarFeeTier || proposal.ispIarFeeTier || "",
        iarFeeType: parsed.iarFeeType || proposal.ispIarFeeType || "",
        iarFeeFlat: parsed.iarFeeFlat || proposal.ispIarFeeFlat || "",
        iarFeeScheduleType:
          parsed.iarFeeScheduleType ||
          proposal.ispIarFeeScheduleType ||
          "Schedule 1",
        fusionAllocations: Array.isArray(parsed.fusionAllocations)
          ? parsed.fusionAllocations
          : [],
      };
    } catch (error) {
      console.error("Error parsing ispFormData for details modal:", error);
      return null;
    }
  };

  render() {
    const { show, onHide, proposal, lists } = this.props;

    if (!show || !proposal) return null;

    const normalizedState = this.normalizeISPState(proposal);

    return (
      <>
        <div
          className={`modal-backdrop fade ${show ? "show" : ""}`}
          style={{ display: show ? "block" : "none" }}
          onClick={onHide}
        />

        <div
          className={`modal fade ${show ? "show" : ""}`}
          tabIndex="-1"
          role="dialog"
          style={{
            display: show ? "block" : "none",
            overflowY: "auto",
          }}
          onClick={onHide}
        >
          <div
            className="modal-dialog modal-xl modal-dialog-scrollable"
            role="document"
            style={{
              maxHeight: "90vh",
              margin: "1.75rem auto",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content" style={{ maxHeight: "90vh" }}>
              <div className="modal-header">
                <h5 className="modal-title vicus-blue">ISP Details</h5>
                <button
                  type="button"
                  className="close"
                  onClick={onHide}
                  aria-label="Close"
                >
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>

              <div
                className="modal-body"
                style={{ overflowY: "auto", maxHeight: "calc(90vh - 120px)" }}
              >
                {normalizedState ? (
                  <ISPConfirm
                    state={normalizedState}
                    lists={lists || {}}
                    isFormValid={true}
                    onSubmit={() => {}}
                    isSubmitting={false}
                    submitError=""
                    viewOnly={true}
                  />
                ) : (
                  <div className="alert alert-danger" role="alert">
                    Unable to load the saved ISP details for this submission.
                  </div>
                )}
              </div>

              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={onHide}
                  style={{
                    paddingLeft: "30px",
                    paddingRight: "30px",
                  }}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
